// extracted by mini-css-extract-plugin
module.exports = {"error":"b16f46","error_icon":"_85a919","error__icon":"_1b9a2b","error__text":"_65e665"};